"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceProfile = void 0;
const class_validator_1 = require("class-validator");
const property_1 = require("../../decorators/property");
class DeviceProfile {
}
exports.DeviceProfile = DeviceProfile;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DeviceProfile.prototype, "platform", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "osVersion", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ type: [String], required: false }),
    __metadata("design:type", Array)
], DeviceProfile.prototype, "supportedVideoCodecs", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ type: [String], required: false }),
    __metadata("design:type", Array)
], DeviceProfile.prototype, "supportedAudioCodecs", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "brand", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "designName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "deviceName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "deviceYearClass", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", Boolean)
], DeviceProfile.prototype, "isDevice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "deviceType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "manufacturer", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "modelId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "modelName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "osName", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", Number)
], DeviceProfile.prototype, "platformApiLevel", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ type: [String], required: false }),
    __metadata("design:type", Array)
], DeviceProfile.prototype, "supportedCpuArchitectures", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "deviceMemory", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], DeviceProfile.prototype, "userAgent", void 0);
